import * as _ from "lodash";
import { inject } from "mobx-react";
import React, { Component } from "react";
import {
  formatDate as formatDateTz,
  formatTimeWithoutSeconds,
  formatTime,
} from "../dateTimeUtils";
import "./grid.scss";
import GridLabels from "./GridLabels";
import warningIcon from "./warning.svg";
import PopOver from "../PopOver/PopOver";

const formatDate = (d) => formatDateTz(d);
class Grid extends Component {
  componentDidMount() {
    if (!this.props.reverse) {
      const widget = this.refGrid.closest(".widget");
      widget.scrollLeft = widget.scrollWidth;
      requestAnimationFrame(() => (widget.scrollLeft = widget.scrollWidth));
    }
  }

  render() {
    const dates = this.dates;
    const className = ["grid"];

    if (this.props.reverse) {
      className.push("reverse");
    }

    return this.props.labs && this.props.labs.groups ? (
      <div className={className.join(" ")} ref={(ref) => (this.refGrid = ref)}>
        {this.props.reverse ? <GridLabels labs={this.props.labs} /> : null}
        <div className="groups">
          {this.props.labs.groups.map((group) => (
            <div className="group" key={group.title}>
              {dates
                .map(formatDate)
                .reduce((acc, date) => {
                  let prevTH = acc[acc.length - 1];
                  if (prevTH && date === prevTH.date) {
                    prevTH.count += 1;
                  } else {
                    acc.push({ date: date, count: 1 });
                  }
                  return acc;
                }, [])
                .map((th, i) => (
                  <div className="labs-grid" key={i}>
                    <table className="date-headers">
                      <thead>
                        <tr className="dates">
                          <th key={th.date} colSpan={th.count}>
                            <span>{th.date}</span>
                          </th>
                        </tr>
                        <tr className="times">
                          {_.sortedUniqBy(
                            dates.filter(
                              (_date) => formatDate(_date) === th.date,
                            ),
                            formatTimeWithoutSeconds,
                          ).map((date) => (
                            <th key={date}>{formatTimeWithoutSeconds(date)}</th>
                          ))}
                        </tr>
                      </thead>
                    </table>
                    <table>
                      <tbody>
                        {(group.items || []).map((item, i) => (
                          <tr
                            key={item.id || i}
                            className={item.title
                              .toLowerCase()
                              .replace(/[^a-z\d]+/g, "-")}
                          >
                            {_.sortedUniqBy(
                              dates.filter(
                                (date) => formatDate(date) === th.date,
                              ),
                              formatTimeWithoutSeconds,
                            ).map((date, i) => {
                              let labs = item.values
                                .filter((v) => {
                                  return (
                                    formatTimeWithoutSeconds(v.dateTime) ===
                                    formatTimeWithoutSeconds(date)
                                  );
                                })
                                .sort(
                                  (a, b) =>
                                    new Date(b.dateTime) - new Date(a.dateTime),
                                );

                              const lab = labs[0];
                              return (
                                <td
                                  key={_.get(lab, "eventId", i)}
                                  className={this.labClasses(lab).join(" ")}
                                  onClick={(e) => this.labClick(lab, e)}
                                >
                                  {labs.length > 1 && lab?.value ? (
                                    <>
                                      <PopOver key={i} trigger={labs.length}>
                                        {labs.map((lab, i) => (
                                          <div key={i}>
                                            {lab.value} - (
                                            {formatTime(lab.dateTime)})
                                          </div>
                                        ))}
                                      </PopOver>
                                    </>
                                  ) : null}
                                  {lab
                                    ? lab.value
                                      ? lab.value
                                      : lab.hasNotes
                                        ? "See Note"
                                        : null
                                    : null}
                                  {_.includes(
                                    ["C", "P"],
                                    _.get(lab, "normalcyType"),
                                  ) ? (
                                    <img
                                      src={warningIcon}
                                      alt="warning"
                                      style={{ height: "1em" }}
                                    />
                                  ) : null}
                                  {_.includes(
                                    ["A"],
                                    _.get(lab, "normalcyType"),
                                  ) ? (
                                    <div className="normalcy-type-a-text">
                                      ABNORMAL
                                    </div>
                                  ) : null}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ))}
            </div>
          ))}
        </div>
        {this.props.reverse ? null : <GridLabels labs={this.props.labs} />}
      </div>
    ) : null;
  }

  labClick(lab) {
    if (!(lab && lab.eventId && lab.orderId)) return;
    this.props.history.push(
      `/patient/${this.props.store.patient.asmpid}/lab/event/${
        lab.eventId
      }/order/${lab.orderId}${lab.hasCorrections ? "/has-corrections" : ""}`,
    );
  }

  labClasses(lab) {
    let classes = [];
    if (lab) {
      if (lab.normalcyType) {
        classes.push(`normalcy-type-${lab.normalcyType.toLowerCase()}`);
      }
      if (lab.hasCorrections) {
        classes.push("has-corrections");
      }
      if (lab.hasNotes) {
        classes.push("has-notes");
      }
      if (lab.eventId && lab.orderId) {
        classes.push("clickable");
      }
    }
    return classes;
  }

  get dates() {
    const dates = this.props.labs
      ? this.props.labs.groups.reduce((datesArray, group) => {
          return group.items
            ? _.sortBy(
                _.uniq(
                  datesArray.concat(
                    group.items
                      .slice()
                      .reduce(
                        (itemAcc, item) =>
                          itemAcc.concat(
                            item.values.map((value) => value.dateTime),
                          ),
                        [],
                      ),
                  ),
                ),
              )
            : datesArray;
        }, [])
      : [];
    return this.props.reverse ? dates.reverse() : dates;
  }
}

export default inject("store")(Grid);
